//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { getLocationPageInformation } from '~/utils/server'
import FaqItems from '~/components/Flotillas/FaqItems'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import flotilla from '~/mixins/page/flotilla'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import RequestBoatModal from '~/components/modal/boat/request-boat-modal'
import RequestOfferForm from '~/components/form/user/request-offer-form'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'FlotillaPage',
  components: {
    FaqItems,
    RequestBoatModal,
    RequestOfferForm
  },
  filters: {
    formattedDate (inDate, inFormat, outFormat) {
      const t = inDate.split('-')
      if (t.length === 3) {
        return t[2] + '/' + t[1] + '/' + t[0]
      } else {
        return inDate
      }
    },
    resizeImageUrl (url, width, height) {
      let result = `${url}`
      if (result.match(/&w=\d*/)) {
        result = result.replace(/&w=\d*/, `&w=${width}`)
      } else {
        result += `&w=${width}`
      }
      if (result.match(/&h=\d*/)) {
        result = result.replace(/&h=\d*/, `&h=${height}`)
      } else {
        result += `&h=${height}`
      }
      result = result.replace(/&rect=(\d+(,\d+)*)/, '')
      return result
    }
  },
  mixins: [pageMeta, flotilla],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      let lang = ctx.store.getters['lang/locale']
      let ietf = ietfLocale || 'en-gb'

      if (lang === 'us') {
        lang = 'en'
        ietf = 'en-gb'
      }

      const country = ctx.route.params.country
      const location = ctx.route.params.location

      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'flotilla_location',
          idx: ctx.route.params.location,
          path: ctx.route.path,
          params: {country}
        }
      })

      const locationInformation = await getLocationPageInformation(ctx, {
        lang, ietf, countryName: country, locationName: location
      })
      if (!locationInformation.location_name) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'flotilla location', params: {lang: 'en'} }).href)
        return
      }

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [
        {
          title: ctx.app.i18n.t('flotillas'),
          url: ctx.app.router.resolve({ name: 'flotillas', params: { lang: ctx.store.getters['lang/locale'] } }).href
        },
        {
          title: locationInformation.country_uid,
          url: ctx.app.router.resolve({ name: 'flotilla page', params: { country, lang: ctx.store.getters['lang/locale'] } }).href
        },
        {
          title: locationInformation.uid,
          url: ctx.app.router.resolve({
            name: 'flotilla location', params: { country, location: locationInformation.uid, lang: ctx.store.getters['lang/locale'] }
          }).href
        }
      ])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      return { locationInformation, country, location }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      currentSlide: 0,
      page: {
        sticky: false
      }
    }
  },
  computed: {
    getSliderImages () {
      const result = [...this.locationInformation.image_slider]
      result.push(result.shift())
      return result.map((i) => {
        return {
          ...i.slider_image
        }
      })
    },
    currentImageUrl () {
      return this.getSliderImages[this.currentSlide]?.url || ''
    },
    ...mapState({
      pageSeoData: state => state.pageData,
      lang: state => state.lang.locale
    }),
    getSliderSettings: app => (name) => {
      const SETTINGS = {
        main: {
          slidesToShow: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: true
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                dots: true,
                arrows: true
              }
            }
          ]
        }
      }
      return {
        settings: {
          type: 'slider',
          arrows: false,
          gaps: {
            value: 24
          }
        },
        ...SETTINGS[name]
      }
    }
  },
  methods: {
    nextSlide () {
      if (this.currentSlide + 1 < this.locationInformation?.image_slider.length) {
        this.currentSlide += 1
      }
    },
    prevSlide () {
      if (this.currentSlide >= 1) {
        this.currentSlide -= 1
      }
    },
    setSticky (isVisible, entry) {
      this.page.sticky = !isVisible
    },
    scrollToElement ($element) {
      const offset = 100
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = document.getElementById($element).getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  },
  jsonld () {
    return {
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: this.locationInformation.location_name,
      organizer: {
        '@type': 'Organization',
        name: 'Tubber',
        url: `https://www.tubber.com/${this.lang}/`
      },
      startDate: this.locationInformation.start_date,
      endDate: this.locationInformation.end_date,
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      eventStatus: 'https://schema.org/EventScheduled',
      location: {
        '@type': 'Place',
        name: this.locationInformation.marina_name || this.locationInformation.location_name,
        address: this.locationInformation.marina_address || this.locationInformation.location_name
      },
      image: this.locationInformation.image_slider
        .map(image => image.slider_image.url),
      description: this.locationInformation.location_description_plain,
      performer: {
        '@type': 'PerformingGroup',
        name: this.locationInformation.flotilla_leader_title
      },
      offers: [{
        '@type': 'Offer',
        url: `https://www.tubber.com${this.$route.fullPath}`,
        availability: 'https://schema.org/InStock',
        price: '695',
        priceCurrency: 'EUR',
        validFrom: this.locationInformation.start_date
      }]
    }
  }
}
